import { useMutation } from 'react-query';

import { GAMFAVerify, verifyMFACode } from '../../lib/api';

// This for SMS Verify
export function useMutateVerifySmsMfa() {
  return useMutation(verifyMFACode);
}
export function useMutateVerifyGMFACode() {
  return useMutation(GAMFAVerify);
}
